






































import { computed, defineComponent, ref } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import useFollowing from "@/hooks/useFollowing";
import { MediaFilesController } from "@/lib/MediaFilesController";
import { getProfileUrl } from "@/lib/urlHelpers";
import BaseAvatar from "@/components/BaseAvatar";
import BaseButton from "@/components/BaseButton";

export default defineComponent({
  name: "SuggestedCreatorsItem",
  components: { BaseAvatar, BaseButton },
  props: {
    user: { type: Object as () => UserPublicData, required: true },
    following: { type: Boolean, default: false },
  },
  setup(props) {
    const { toggle } = useFollowing(ref([]));
    const showFollow = ref(true);
    const processingFollow = ref(false);
    const backgroundUrl = computed<string>(() =>
      !!props.user?.background ? MediaFilesController.getImageThumbnail(props.user?.background?.urlPart ?? "", 140) : ""
    );
    const profileUrl = computed(() => getProfileUrl(props.user));
    const onFollow = async () => {
      try {
        processingFollow.value = true;
        const status = await toggle(props.user.id);
        showFollow.value = !status;
      } finally {
        processingFollow.value = false;
      }
    };
    return {
      backgroundUrl,
      profileUrl,
      showFollow,
      processingFollow,
      onFollow,
    };
  },
});
